import { useAuth } from 'src/context/AuthContext'
import { DefaultService, UsersService, AppClientFiltersService } from 'src/services/openApiV2'
import { get } from 'src/utils/config/lodashUtils'
import { UserBNameNoAuthType } from '../utils/types'

export default function useFilterDataServiceHook() {

  
  const { currentUser } = useAuth()

  /**
   * by this function we get all the data of filters related to specific ORG
   */
  const getAllFiltersData = async (org?: string) => {
    try {
      if (!org) return []
      const res = await DefaultService.getChainFiltersChainFiltersPost({
        requestBody: {
          chain_in: org
        }
      })
      return res
    } catch (err) {
      console.log('get all filters data: ', err)
      throw err
    }
  }

  /**
   * This function sets the b_names that is assigned to the user (mainly for `store-manager` access level)
   * @returns
   */
  const getUserAssignedBNamesData = async () => {
    try {
      if (!get(currentUser, 'org', false)) return []

      const res: UserBNameNoAuthType = (await UsersService.getBnamesByUserNoAuthUserBnamesNoAuthGet({
        userId: get(currentUser, 'uid', ''),
        limit: 100000
      })) as any
      return get(res, 'items', [] as typeof res.items)
    } catch (err) {
      console.log('getUserAssignedBNamesData: ', err)
      throw err
    }
  }

  /**
   * New function to get chain filters directly from app-client API
   * This API returns the bnames directly assigned to the user
   */
  const getChainFiltersV1 = async () => {
    try {
      const res = await AppClientFiltersService.getChainFiltersV1ChainFiltersGet({
        requireOrg: false
      })
      return res
    } catch (err: any) {
      console.error('[NewFilterContext] Error calling getChainFiltersV1:', err?.message || err)
      throw err
    }
  }

  /**
   * New function to get date filter config from app-client API
   */
  const getDateFilterConfig = async () => {
    try {
      const res = await AppClientFiltersService.getDateFilterConfigV1ModuleDateFilterConfigPost({
        requestBody: {
          module: []
        }
      })
      return res
    } catch (err: any) {
      console.error('[NewFilterContext] Error calling getDateFilterConfig:', err?.message || err)
      throw err
    }
  }

  return {
    getAllFiltersData,
    getUserAssignedBNamesData,
    getChainFiltersV1,
    getDateFilterConfig
  }
}
